export default __webpack_public_path__ + "static/media/userSubscriptionDark.c8b98267.svg";